import React from 'react';
import { PureComponent } from '../../../../dispatcher/modules';
import Container from '../../../layout/container/Container';
import { PUZZLE_TOGGLE_PROPS } from './Types';

/**
 * Custom Toggle Component with addition of support a11y. It consists of the toggle label which describes the toggle
 * itself, the switcher options(left and right labels), the switcher button which toggle active/inactive state of each
 * switcher option
 * @author Aleksandar Cosic / Stevan Stojanovic
 */
class PuzzleToggle extends PureComponent<PUZZLE_TOGGLE_PROPS, {}> {
  /**
   * Toggle active tab
   */
  toggleActiveTab = () => {
    const { switcherOptions, setActiveTab } = this.props;
    const activeTab = this.props.activeTab === switcherOptions[0].name ? switcherOptions[1].name : switcherOptions[0].name;
    setActiveTab(activeTab);
  };

  render() {
    const {
      switcherLabel,
      switcherOptions,
      checked,
      id,
      cssClass = '',
      disabled
    } = this.props;

    const firstLabelActiveCls = !checked ? 'tp-active' : '';
    const secondLabelActiveCls = checked ? 'tp-active' : '';
    const switcherCls = checked ? 'tp-switch-on' : 'tp-switch-off';
    const firstOption = switcherOptions[0];
    const secondOption = switcherOptions[1];
    const toggleDisabledCls = disabled ? 'k-state-disabled' : '';

    return (
      <Container
        aria-labelledby={`switcherLabel_${id}`}
        hBox
        alignItemsCenter
        className={`tp-switcher-wrapper tp-text-semibold ${toggleDisabledCls ? toggleDisabledCls + ' ' : ''}${cssClass}`}
        role={'radiogroup'}
      >
        <span
          id={`switcherLabel_${id}`}
          className={'tp-switcher-label'}
        >
          {switcherLabel}
        </span>
        <label
          className={firstLabelActiveCls}
          data-cy={checked ? 'inactive' : 'active'}
        >
          {firstOption.locale}
        </label>
        <span className={`tp-switch ${switcherCls}`}>
          <button
            onClick={this.toggleActiveTab}
            className={'tp-switch-container'}
            data-cy={'switch-container'}
            role={'checkbox'}
            aria-checked={checked}
            disabled={disabled}
          >
            <span
              className={'sr-only'}
            >{!checked ? firstOption.locale : secondOption.locale}</span>
          </button>
        </span>
        <label
          className={secondLabelActiveCls}
          data-cy={checked ? 'active' : 'inactive'}
        >
          {secondOption.locale}
        </label>
      </Container>
    );
  }
}

export default PuzzleToggle;
